import { ca } from '@cian/analytics';

export type TCompareHubCategory = 'Compare' | 'CompareJK';

export function trackCompareHubLinkClick(category: TCompareHubCategory) {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'click',
    label: 'to_compare',
  });
}
